
import * as antIcons from '@ant-design/icons-vue';
import {isUrl} from '../../util.js';

export default {
  name: 'EleProSidebarItem',
  components: {...antIcons},
  props: {
    // item数据
    item: {
      type: Object,
      required: true
    },
    // 一级pop菜单class
    firstPopClass: String
  },
  computed: {
    /* 是否有子级 */
    haveChildren() {
      return !!(this.item.children && this.item.children.filter((d) => !d.meta.hide).length);
    },
    /* 是否是网址 */
    isUrl() {
      return isUrl(this.item.path);
    }
  }
}
